import React from 'react'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { useController, UseControllerProps, useFormContext } from 'react-hook-form'
import { format } from 'date-fns'

// RegisteredDatePicker Component
function RegisteredDatePicker({
    name,
    validation,
    ...props
}: DatePickerProps & {
    name: string
    validation?: UseControllerProps['rules']
}) {
    const { control } = useFormContext()

    // Using react-hook-form's useController to manage DatePicker state
    const {
        field: { onChange, value },
        fieldState: { error },
    } = useController({
        name,
        control,
        rules: validation,
    })

    // Handle date change and format to 'yyyy-MM-dd' before updating react-hook-form state
    const handleDateChange = (date: Date | null) => {
        if (date && !isNaN(date.getTime())) {
            onChange(format(date, 'yyyy-MM-dd'))
        } else {
            onChange(null)
        }
    }

    return (
        <DatePicker
            {...props}
            value={value ? new Date(value) : null}
            onChange={handleDateChange}
            slotProps={{
                textField: {
                    error: !!error,
                    helperText: error ? error.message : '',
                    variant: 'outlined',
                    slotProps: {
                        inputLabel: {
                            shrink: true,
                        },
                    },
                },
            }}
        />
    )
}

export { RegisteredDatePicker }
